import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

const FinalGrade = ({ rating }: { rating: number | "-" }) => {
  const theme = useAtomValue(themeAtom);
  return (
    <div className="flex items-center">
      <strong className={twMerge("text-[18px]", theme.home.tailwind.textDefault)}>{rating}</strong>
      <span className={twMerge("text-[12px] font-bold", theme.vesselDetails.fields)}>/5</span>
    </div>
  );
};

export default FinalGrade;
